<template>
  <div>
    <div
      v-for="(stagesByCustomer, stagesByCustomerIndex) in stagesByCustomers"
      :key="`customer-${stagesByCustomerIndex}`"
    >
      <p class="has-text-weight-bold text-underline">
        {{ stagesByCustomer.customer.firstname }} {{ stagesByCustomer.customer.lastname }}
      </p>
      <div class="pl-3 mb-3 mt-1">
        <div
          v-for="(plannedStage, plannedStageIndex) in stagesByCustomer.plannedStages"
          :key="`planned-stage-${plannedStageIndex}`"
          class="box mb-2"
        >
          <b-icon size="is-small" icon="circle" :style="`font-size: 0.8em; color: ${plannedStage.level.color_code}`" /> {{ plannedStage.level.name }} {{ plannedStageAge(plannedStage) }}, {{ timeTitle(plannedStage) }}<br>
          {{ plannedStage.number_of_lesson }} séances du {{ plannedStage.start_date | dateFormat("DD MMMM YYYY") }} au {{ plannedStage.end_date | dateFormat("DD MMMM YYYY") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { DateHelpers } from "@/mixins/DateHelpers";
import VueI18n from "vue-i18n";
import {LocaleMixin} from "@/mixins/LocaleMixin";

export default {
  name: 'CustomersStagesList',
  mixins: [DateHelpers, LocaleMixin],

  props: {
    stagesByCustomers: {
      type: Array,
      required: true
    },
    removeStageToCustomer: {
      type: Function,
      required: true
    }
  },

  methods: {
    timeTitle (plannedStage) {
      const days = []
      for (const day of plannedStage.repetition_days) {
        days.push(this.$t(`days.day${day}`))
      }
      return `Le ${days.join(', ').toLowerCase()} de ${moment(plannedStage.start_time).format('HH:mm')} à ${moment(plannedStage.end_time).format('HH:mm')}`;
    },

    plannedStageAge (plannedStage) {
      if (plannedStage.min_age >= 18) {
        return `Adulte`;
      } else if (plannedStage.min_age !== plannedStage.max_age) {
        return `${plannedStage.min_age}-${plannedStage.max_age} ans`;
      } else {
        return `${plannedStage.min_age} ans`;
      }
    }
  },

  // Translate component
  mounted () {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        days: {
          0: "Sunday"
        },
      },
      fr: {
        days: {
          day0: "Dimanche",
          day1: "Lundi",
          day2: "Mardi",
          day3: "Mercredi",
          day4: "Jeudi",
          day5: "Vendredi",
          day6: "Samedi"
        },
      }
    }
  })
}
</script>
